import { FilterState } from '@Component/Filter/utils';
import { ColumnType } from '@Hooks/useOrdering';
import { useOverviewTableFilters } from '@Page/Overview/hooks/useSalaryOverviewTableFilters';
import { Settings, TableColumnSetting, TableColumnsSetting } from '@tlx/astro-shared';
import { IntlShape, useIntl } from 'react-intl';
import { useSalarySettings } from '@Page/Onboarding/hooks/useSalarySettings.ts';

export const OVERVIEW_TABLE_COLUMNS_SETTING_KEY = 'overview-table-columns';

export function OverviewDisplayOptions() {
    const intl = useIntl();
    const label = intl.formatMessage({ id: 'text_columns' });

    const moduleSalaryApproval = useSalarySettings().data?.moduleSalaryApproval;
    const defaultColumns = getDefaultColumns(intl, useOverviewTableFilters(), moduleSalaryApproval);
    const columns = getColumns(intl, useOverviewTableFilters(), moduleSalaryApproval);

    return (
        <div className="atl-mr-8">
            <Settings>
                <TableColumnsSetting
                    name={OVERVIEW_TABLE_COLUMNS_SETTING_KEY}
                    label={label}
                    aria-label={label}
                    defaultColumns={defaultColumns.map((column) => column.id)}
                >
                    {columns.map((column) => (
                        <TableColumnSetting value={column.id} key={column.id}>
                            {column.label}
                        </TableColumnSetting>
                    ))}
                </TableColumnsSetting>
            </Settings>
        </div>
    );
}

export const getDefaultColumns = (
    intl: IntlShape,
    filters: FilterState,
    moduleSalaryApproval: boolean | undefined,
): ColumnType[] => {
    return getColumns(intl, filters, moduleSalaryApproval).filter((column) => !column.defaultDisabled);
};

export const getColumns = (intl: IntlShape, filters: FilterState, moduleSalaryApproval: boolean | undefined) => {
    const { formatMessage } = intl;
    const salaryPageNotSelected = !(
        filters.contentFilter.query == 'pension' || filters.contentFilter.query == 'reimbursement'
    );

    // const isFullPakkeOrTSK = isTSKCompanyOrFullPakke();

    const defaultColumns: ColumnType[] = [
        {
            id: 'datePeriod',
            label: formatMessage({ id: 'text_period' }),
            width: 'minmax(150px, 1fr)',
        },
        {
            id: 'voucherDate',
            label: formatMessage({ id: 'text_voucher_date' }),
            width: '1fr',
        },
        {
            id: 'voucherNumberAsString',
            label: formatMessage({ id: 'text_voucher_number' }),
            width: '1fr',
        },
        {
            id: 'ameldingStatus',
            label: formatMessage({ id: 'text_amelding' }),
            width: '1fr',
        },
    ];

    if (salaryPageNotSelected) {
        defaultColumns.push({
            id: 'paymentDate',
            label: formatMessage({ id: 'text_payment_date' }),
            width: '1fr',
        });
    }
    defaultColumns.push({
        id: 'payrollTaxBasisAmount',
        label: formatMessage({ id: 'tsk_eni_basis' }),
        align: 'right',
    });

    if (moduleSalaryApproval) {
        defaultColumns.push({
            id: 'approvedBy',
            label: formatMessage({ id: 'tsk_text_salary_approval' }),
            width: '1fr',
        });
    }

    // if (salaryPageNotSelected) {
    //     defaultColumns.push({
    //         id: 'wagePeriodTransactionId',
    //         label: formatMessage({ id: 'text_tax_aga' }),
    //         width: '1fr',
    //     });
    // }

    return defaultColumns;
};
